// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"134":"1e745980","940":"f1ad04f1"}[chunkId] + ".chunk.css";
};